import { getSearchExpandedIds as e } from "./helpers/getSearchExpandedIds.js";
import { getVisibleNodes as t } from "./helpers/getVisibleNodes.js";
import { getLeafNodeIds as n, hasChildren as r } from "./helpers/selectionProcessing.js";
import { TreeNodeElement as i } from "./TreeNodeElement/TreeNodeElement.js";
import { TreeSkeleton as a } from "./TreeSkeleton/TreeSkeleton.js";
import o from "./Tree.module.js";
import s from "classnames";
import { useRef as c, useState as l } from "react";
import { jsx as u } from "react/jsx-runtime";
import { useVirtualizer as d } from "@tanstack/react-virtual";
//#region src/components/Tree/Tree.tsx
var f = 36, p = (p) => {
	let { className: m, data: h, defaultExpandedIds: g = [], resetExpandedOnDataChange: _ = !0, selection: v, search: y, searchExpandedIds: b, isLoading: x, onSelectionChange: S, onItemExpansionChange: C, onItemSelect: w } = p, [T, E] = l(() => new Set(g)), [D, O] = l(y), [k, A] = l(h), [j, M] = l(b), N = c(null), P = (e) => {
		let { id: t } = e, n = new Set(T), r = !n.has(t);
		r ? n.add(t) : n.delete(t), E(n), C?.(e, r);
	}, F = y !== D, I = h !== k, L = b?.length !== j?.length || !!b?.some((e) => !j?.includes(e));
	(F || I || L) && (O(y), A(h), M(b), (F || _ || y.length >= 3 && (L || !b)) && (y.length >= 3 ? E(b ? new Set(b) : e(h, y)) : E(new Set(g))));
	let R = (e, t) => {
		w?.(e, t);
		let i = r(e), a = i ? n([e]) : [e.id], o = Array.from(a).reduce((n, r) => ((e.selectable || i) && (t ? n.add(r) : n.delete(r)), n), new Set(v));
		S?.(o);
	}, z = t(h, T), B = d({
		count: z.length,
		estimateSize: () => f,
		getItemKey: (e) => z[e].node.id,
		getScrollElement: () => N.current,
		overscan: 10
	});
	return /* @__PURE__ */ u("div", {
		ref: N,
		className: s(o.tree, m, { [o.loading]: x }),
		children: x ? /* @__PURE__ */ u(a, {}) : /* @__PURE__ */ u("div", {
			className: o.items,
			style: { height: B.getTotalSize() },
			children: B.getVirtualItems().map(({ index: e, key: t, start: n }) => {
				let { depth: r, node: a } = z[e];
				return /* @__PURE__ */ u("div", {
					ref: B.measureElement,
					className: o.item,
					"data-index": e,
					style: { transform: `translateY(${n}px)` },
					children: /* @__PURE__ */ u(i, {
						depth: r,
						node: a,
						selection: v,
						expandedIds: T,
						onExpandToggle: P,
						onSelect: R,
						search: y
					})
				}, t);
			})
		})
	});
};
//#endregion
export { p as Tree };
